// extracted by mini-css-extract-plugin
export default {"list__item":"CityCard_list__item__G4HhH"};